import styled from 'styled-components';

export const StickyTableWrapper = styled.div`
  height: 100%;
  overflow: hidden;

  display: flex;
  flex-direction: column;
`;

const DisplayGrid = styled.div`
  display: grid;
`;

export const StickyTableHeader = styled(DisplayGrid)``;

export const StickyTableBody = styled(DisplayGrid)``;

export const StickyTableBodyWrapper = styled.div`
  flex: 1;
  overflow: auto;
`;

export const StickyCellWrapper = styled.div`
  position: relative;
`;

export const StickyCellContent = styled.div`
  position: sticky;
`;

export const NonStickyCellWrapper = styled.div`
  display: flex;
  flex-direction: column;
`;
